export const createCurrencyTV = (currencies) => {
  return currencies ? currencies.map (c => {
    return {
      text: c.currency_iso,
      value: c.currency_id
    };
  }): [];
}